import { Component, Input, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { HotCatStatus, HotCatService } from 'src/app/core/services/hot.cat.service';
import { KaikasService, LoginInfo } from 'src/app/core/services/kaikas.service';

@Component({
  selector: 'app-bidding-game',
  templateUrl: './bidding-game.component.html',
  styleUrls: ['./bidding-game.component.scss']
})
export class BiddingGameComponent implements OnInit {
  @Input() contract: string = "";

  private onStatus?:Subscription;
  private onLoginSubscription?:Subscription;

  public hasAllowance:boolean = false;
  public addressAllowance:string = "";
  public status:Observable<HotCatStatus>;
  public currentUser:string = "";


  displayedColumns: string[] = ['address', 'timeHold', 'CATC'];

  constructor(
    private hotCatService: HotCatService,
    private kaikas: KaikasService
  ) { }

  public bid() {
    this.hotCatService.bid(this.contract);
  }

  public approve() {
    this.hotCatService.makeAllowance(this.contract).pipe(take(1)).subscribe({
      complete: ()=>{
        this.refreshAllowance();
      }
    });
  }

  public refresh() {
    this.hotCatService.refreshStatus(this.contract);
  }

  ngOnInit() {
    this.status = this.hotCatService.status(this.contract)!;
    this.onStatus = this.hotCatService.status(this.contract)?.subscribe((data:HotCatStatus)=>{

    });

    this.hotCatService.refreshStatus(this.contract);

    this.onLoginSubscription = this.kaikas.loginInfoObserver.subscribe((loginInfo:LoginInfo)=>{
      this.currentUser = loginInfo.address;
      if (this.hasAllowance == false || this.addressAllowance != this.currentUser)
        this.refreshAllowance();
    });
  }

  public refreshAllowance() {
    this.hotCatService.hasAllowanceToBid(this.contract).pipe(take(1)).subscribe((hasAllowance)=>{
      this.hasAllowance = hasAllowance;
      if (hasAllowance == true)
        this.addressAllowance = this.currentUser;
    });
  }

  ngOnDestroy() {
    this.onStatus?.unsubscribe();
    this.onLoginSubscription?.unsubscribe();
  }

}
